<template lang="html">
  <li
    class="navigation__item"
  >
    <div class="navigation__button">
      <div
        class="navigation__text"
      >
        <slot />
      </div>
      <div
        v-if="$slots['toggable']"
        :class="[
          toggled && 'navigation__toggle--active',
        ]"
        class="navigation__toggle"
        @click="handleToggle"
      >
        <ArrowDownIcon class="navigation__toggle-icon" />
      </div>
    </div>
    <div
      v-if="$slots['toggable']"
      v-show="toggled"
      class="navigation__toggable"
    >
      <slot name="toggable" />
    </div>
  </li>
</template>

<script>
import ArrowDownIcon from 'beisheim/assets/images/icons/beisheim-stiftung-dropdown.svg'

export default {
  components: {
    ArrowDownIcon
  },
  data () {
    return {
      toggled: false
    }
  },
  methods: {
    handleToggle (e) {
      this.toggled = !this.toggled
      this.$emit('toggle', e)
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/font-sizes';

  .navigation__item {
    color: gray(1);
    border-bottom: 1px solid gray(3);

    &:first-child {
      border-top: 1px solid gray(3);
    }
  }

  .navigation__button {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .navigation__text {
    font-size: font-size(1);
    display: block;
    cursor: pointer;
    width: 100%;
    padding: scale(4) scale(2);

    .router-link-exact-active {
      text-decoration: underline;
    }
  }

  .navigation__toggable {
    margin-bottom: scale(2);
  }

  .navigation__toggle {
    user-select: none;
    border-left: 1px solid gray(3);
    margin-top: scale(1);
    margin-bottom: scale(1);
    padding: scale(3);
    cursor: pointer;

    &--active {
      .navigation__toggle-icon {
        transform: rotate(180deg);
      }
    }
  }

  .navigation__toggle-icon {
    transition: transform 0.2s ease-in-out;
    width: 12px;
  }
</style>
